import {FormArray} from '@angular/forms';

/**
 * Валидация поля на фронте
 * @param input
 * @returns {{frontendRequired: string}}
 */

export function minLengthValidator(length: Number, message?) {
    return (input: FormArray) => {
        return input.length < length && input.touched ?
            {minLength: message ? message : 'Количество выбранных объектов должно быть не менее ' + length} : null;
    };
}
